'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mention = exports.MentionsInput = undefined;

var _MentionsInput2 = require('./MentionsInput');

var _MentionsInput3 = _interopRequireDefault(_MentionsInput2);

var _Mention2 = require('./Mention');

var _Mention3 = _interopRequireDefault(_Mention2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MentionsInput = _MentionsInput3.default;
exports.Mention = _Mention3.default;